import React from 'react';
import { Box, Heading, Text, Button, RayIcon } from '@razorpay/blade/components';
import { useRayContext } from 'components/RayAiBot/context/RayContext';
import { rayActionTypes } from 'components/RayAiBot/context/data';
import { SuggestionCard } from './styles';

const suggestionQuestions = [
  'Why has my salary decreased?',
  'When was my salary revised?',
  'Explain my TDS calculation?',
];

export const SuggestionBox = ({ onClose }: { onClose: () => void }) => {
  const { dispatch } = useRayContext();

  const handleSelectSuggestion = (suggestion: string) => {
    dispatch({
      type: rayActionTypes.SET_INITIAL_QUERY,
      payload: suggestion,
    });
    openChat();
  };

  const openChat = () => {
    dispatch({
      type: rayActionTypes.SET_SHOW_RAY_CHAT,
      payload: true,
    });
    onClose();
  };

  return (
    <Box display="flex" flexDirection="column" gap="spacing.5" padding="spacing.2" width="300px">
      <Box>
        <Heading size="small" weight="semibold">
          Ask Ray Agent
        </Heading>
        <Text weight="regular" color="surface.text.gray.muted">
          Use AI to understand your payslip better
        </Text>
      </Box>
      {suggestionQuestions.map((question, index) => (
        <SuggestionCard key={index} onClick={() => handleSelectSuggestion(question)}>
          <Text size="medium" weight="regular" color="surface.text.gray.normal">
            {question}
          </Text>
        </SuggestionCard>
      ))}

      <Button variant="secondary" iconPosition="left" isFullWidth icon={RayIcon} onClick={openChat}>
        Ask AI
      </Button>
    </Box>
  );
};
